(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.common.component.loader'
  var templateUrl = require('./tpl/loader.html')

  require('./scss/loader.scss')

  require('angular')
    .module(MODULE_NAME, [])
    .component('thismomentLoader', {
      templateUrl: templateUrl,
      bindings: {
        displayBlock: '<',
        loaderColor: '<?',
        loadMessage: '='
      },
      controller: loaderController
    })

  function loaderController () {
    var vm = this
    vm.styles = {}

    vm.$onInit = loaderInit

    function loaderInit () {
      if (!vm.loaderColor) {
        vm.loaderColor = '#6EBE49'
      }

      vm.styles.loader = {
        'color': vm.loaderColor
      }
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/common/component/loader/index.js